module.exports = __webpack_public_path__ + "static/img/FELIX-KNEIPP.be1fe5c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/FELIX-KNEIPP.jpg
// module id = QtKi
// module chunks = 0